var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircleWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64967 19.4384C6.25799 18.0052 7.6783 17 9.33337 17H15.3334C16.9885 17 18.4087 18.0052 19.0171 19.4384M16.3334 9.5C16.3334 11.7091 14.5425 13.5 12.3334 13.5C10.1242 13.5 8.33337 11.7091 8.33337 9.5C8.33337 7.29086 10.1242 5.5 12.3334 5.5C14.5425 5.5 16.3334 7.29086 16.3334 9.5ZM22.3334 12C22.3334 17.5228 17.8562 22 12.3334 22C6.81053 22 2.33337 17.5228 2.33337 12C2.33337 6.47715 6.81053 2 12.3334 2C17.8562 2 22.3334 6.47715 22.3334 12Z",
    stroke: "#0E9384",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleWhite);
export default __webpack_public_path__ + "static/media/user-circle-white.3d7c840f42aa984036ae811a1d6e3a10.svg";
export { ForwardRef as ReactComponent };